const configTableDashboard = {
    widthAction: 200,
    headers: [
        {
            label: 'CP 番号',
            backgroundColor: '#fff2cc',
            width: 100
        },
        {
            label: 'キャンペーン名',
            backgroundColor: '#fff2cc',
            width: 290
        },
        {
            label: '営業担当',
            backgroundColor: '#fff2cc',
            width: 225
        },
        {
            label: 'ディレクターメイン',
            backgroundColor: '#fff2cc',
            width: 225
        },
        {
            label: 'ディレクターサブ',
            backgroundColor: '#fff2cc',
            width: 160
        },
        {
            label: 'キャンペーン開始年月日（時間）',
            backgroundColor: '#fff2cc',
            width: 230
        },
        {
            label: 'キャンペーン終了年月日（時間）',
            backgroundColor: '#fff2cc',
            width: 230
        },
        {
            label: '事務局開始日（時間）',
            backgroundColor: '#fff2cc',
            width: 230
        },
        {
            label: '事務局終了年月日（時間）',
            backgroundColor: '#fff2cc',
            width: 230
        },
        {
            label: 'ステータス',
            backgroundColor: '#fff2cc',
            width: 170
        },
        {
            label: '種別',
            backgroundColor: '#fff2cc',
            width: 70
        },
        {
            label: '応募種別',
            backgroundColor: '#fff2cc',
            width: 360
        },
        {
            label: 'エンドクライアント',
            backgroundColor: '#fff2cc',
            width: 150
        },
        {
            label: '発注元（代理店）',
            backgroundColor: '#fff2cc',
            width: 150
        },
        {
            label: '当選者数',
            backgroundColor: '#fff2cc',
            width: 100
        },
        {
            label: 'LPサイト',
            backgroundColor: '#fff2cc',
            width: 220
        },
        {
            label: '電話',
            backgroundColor: '#c9daf8',
            width: 120
        },
        {
            label: 'メール',
            backgroundColor: '#c9daf8',
            width: 220
        },
        {
            label: 'パートナー',
            backgroundColor: '#c9daf8',
            width: 370
        },
        {
            label: 'メモ',
            backgroundColor: '#c9daf8',
            width: 220
        },
        {
            label: 'エスカレメイン',
            backgroundColor: '#c9daf8',
            width: 130
        },
        {
            label: 'エスカレサブ',
            backgroundColor: '#c9daf8',
            width: 130
        },
        {
            label: '受注範囲',
            backgroundColor: '#d9ead3',
            width: 300
        },
        {
            label: '事務局パートナー',
            backgroundColor: '#d9ead3',
            width: 150
        },
        {
            label: '利用ツール',
            backgroundColor: '#d9ead3',
            width: 200
        }
    ]
};
export { configTableDashboard };
